import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import SvgIcon from "../../../../parts/SvgIcon";
import { WorkoutFolderWorkoutsPicker } from "./HandleWorkoutFolderModal";

const ManageWorkoutFolderWorkoutsModal = ({ locals }) => {
	const { t } = useTranslation("coaching-portal");
	const { query = {}, workoutFolders = [], savedWorkouts = [] } = locals;
	const folderId = query.targetFolderId;
	const folder = workoutFolders.find((f) => String(f._id) === String(folderId));

	const [selectedIds, setSelectedIds] = useState(
		(folder?.workoutIds || []).map(String),
	);
	const [search, setSearch] = useState("");
	const [submitting, setSubmitting] = useState(false);

	if (!folder) {
		return (
			<Modal
				className="workout-folder-modal"
				title={t(
					"allTemplates.workoutFolders.manageWorkoutsTitle",
					"Manage workouts",
				)}
				toClear={["targetFolderId"]}
			>
				<div className="body">
					<p>
						{t(
							"allTemplates.workoutFolders.folderNotFound",
							"Folder not found.",
						)}
					</p>
				</div>
			</Modal>
		);
	}

	const toggleWorkout = (id) => {
		setSelectedIds((prev) =>
			prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
		);
	};

	const closeModal = () => {
		submit("/actions/refresh", {
			method: "GET",
			body: { modal: "", targetFolderId: "" },
		});
	};

	const handleSave = () => {
		if (submitting) return;
		setSubmitting(true);
		submit("/actions/workout-folders", {
			method: "POST",
			body: {
				id: folder._id,
				name: folder.name,
				description: folder.description || "",
				workoutIds: selectedIds,
			},
		});
	};

	return (
		<Modal
			className="workout-folder-modal manage-workout-folder-modal"
			title={t(
				"allTemplates.workoutFolders.manageWorkoutsTitle",
				"Manage workouts",
			)}
			toClear={["targetFolderId"]}
		>
			<div className="body">
				<div className="workout-folder-manage-summary">
					<SvgIcon src="/img/new-icons/folder.svg" />
					<div>
						<h4>{folder.name}</h4>
						<p>
							{t("allTemplates.workoutFolders.workoutsInFolder", {
								count: selectedIds.length,
								defaultValue_one: "{{count}} workout in this folder",
								defaultValue_other: "{{count}} workouts in this folder",
							})}
						</p>
					</div>
				</div>
				<WorkoutFolderWorkoutsPicker
					savedWorkouts={savedWorkouts}
					workoutFolders={workoutFolders}
					selectedIds={selectedIds}
					onToggle={toggleWorkout}
					folderId={folder._id}
					search={search}
					onSearchChange={setSearch}
				/>
			</div>
			<footer>
				<button
					type="button"
					data-button-type="secondary"
					data-action="cancel"
					onClick={closeModal}
				>
					{t("allTemplates.workoutFolders.cancel", "Cancel")}
				</button>
				<button
					type="button"
					data-button-type="primary"
					disabled={submitting}
					onClick={handleSave}
				>
					{t("allTemplates.workoutFolders.save", "Save")}
				</button>
			</footer>
		</Modal>
	);
};

ManageWorkoutFolderWorkoutsModal.propTypes = {
	locals: PropTypes.object.isRequired,
};

export default ManageWorkoutFolderWorkoutsModal;
